import {useState} from 'react'
import GenericNotificationDisplay from './GenericNotificationDisplay'
import './GuildInvitationNotification.scss'
import {useAcceptGuildInvitationMutation, useRejectGuildInvitationMutation} from '../../../../guild/rtkGuildApi'
import {useDeleteNotificationMutation} from '../rtkNotificationApi'
import Button from '@mui/material/Button'
import {
    NotificationActionCategoryDTO,
    NotificationActionDTO,
    NotificationDTO,
    NotificationParameterDTO
} from '../../../../generated/api'

const GuildInvitationNotification = ({notification}: {notification: NotificationDTO}) => {

    const [acceptGuildInvitation, acceptGuildInvitationResult] = useAcceptGuildInvitationMutation()
    const [rejectGuildInvitation, rejectGuildInvitationResult] = useRejectGuildInvitationMutation()
    const [deleteNotification, deleteNotificationResult] = useDeleteNotificationMutation()
    const [notificationIds, setNotificationIds] = useState<string[]>([])

    const isDisabled =
        acceptGuildInvitationResult.isLoading ||
        rejectGuildInvitationResult.isLoading ||
        deleteNotificationResult.isLoading

    const rejectInvitationAction: NotificationActionDTO | undefined = notification.notificationActions?.find(
        (a) => a.category === NotificationActionCategoryDTO.GuildInvitationReject
    )

    const acceptInvitationAction: NotificationActionDTO | undefined = notification.notificationActions?.find(
        (a) => a.category === NotificationActionCategoryDTO.GuildInvitationApprove
    )

    const guildId: NotificationParameterDTO | undefined = rejectInvitationAction?.parameters?.find(
        (param: NotificationParameterDTO) => param.label === 'guildId'
    )
    const invitedUser: NotificationParameterDTO | undefined = rejectInvitationAction?.parameters?.find(
        (param: NotificationParameterDTO) => param.label === 'invitedUser'
    )

    const getDeclineInvitationButton = () => {
        return (
            <>
                <Button
                    className="notification-action-button reject"
                    id="notification-action-button-reject"
                    type="button"
                    variant="outlined"
                    onClick={() =>
                        rejectGuildInvitation({
                            notificationId: notification.id,
                            guildId: guildId?.value,
                            invitedUserId: invitedUser?.value
                        })
                            .then(() => deleteNotification(notification.id))
                            .then(() => setNotificationIds([...notificationIds, notification.id]))
                    }
                    disabled={isDisabled || notificationIds.includes(notification.id)}
                    loading={rejectGuildInvitationResult.isLoading}
                >
                    Reject
                </Button>
            </>
        )
    }

    const getAcceptInvitationButton = () => {
        return (
            <>
                {
                    <Button
                        className="notification-action-button accept"
                        id="notification-action-button-accept"
                        type="button"
                        variant="contained"
                        onClick={() =>
                            acceptGuildInvitation({
                                notificationId: notification.id,
                                guildId: guildId?.value,
                                invitedUserId: invitedUser?.value
                            })
                                .then(() => deleteNotification(notification.id))
                                .then(() => setNotificationIds([...notificationIds, notification.id]))
                        }
                        disabled={isDisabled || notificationIds.includes(notification.id)}
                        loading={acceptGuildInvitationResult.isLoading}
                    >
                        Accept
                    </Button>
                }
            </>
        )
    }

    return (
        <GenericNotificationDisplay notification={notification} canClose={false} title={'Guild invitation'}>
            {notification.notificationActions && notification.notificationActions.length > 0 && (
                <div className="datx-notification-actions">
                    {rejectInvitationAction && getDeclineInvitationButton()}
                    {acceptInvitationAction && getAcceptInvitationButton()}
                </div>
            )}
        </GenericNotificationDisplay>
    )
}

export default GuildInvitationNotification